import React from 'react';

import './_hero.scss';
import star from './assets/Star.png';

class Hero extends React.PureComponent {
  renderHeroImage() {
    return (
      <section id="imagery">
        <div id="background" />
        <div id="boi" />
        <div id="logo-bg" />
        <div id="spin-star">
          <img src={star} alt="" />
        </div>
        <div id="logo" title="StarKiss Studios" />
      </section>
    );
  }

  renderAbout() {
    return (
      <section id="about">
        <p>
          We are a small software development company specializing in creating
          highly functional and beautiful apps and websites.
        </p>
      </section>
    );
  }

  render() {
    return (
      <header id="hero">
        {this.renderHeroImage()}
        {this.renderAbout()}
      </header>
    );
  }
}

/*
 * If you have an
 * idea that you want realized, don’t hesitate in contacting us.
 */

export default Hero;



// WEBPACK FOOTER //
// ./src/components/hero/index.js